import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AccountService } from 'src/app/services/account.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { SessionDataService } from 'src/app/services/session-data.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { environment } from 'src/environments/environment';
import { VerificationComponent } from '../verification/verification.component';

declare var window: any;
@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
  @Input() label: any;
  @Input() sku: any;
  @Input() addon: any;
  @Input() tracking: any;
  @Input() support: any;
  
  count: any;
  isNavCollapsed: boolean = true;
  toggleDropdown: boolean = false;
  userLoggedIn: boolean = false;
  userData: any;
  language: any = '';
  isArabic: boolean;
  ENV: any;
  currentAccount: any;

  constructor(
    private AS: AccountService,
    private SKUDS: SkuDataService,
    private SS: SubjectService,
    private route: Router,
    private modalController: ModalController,
    private SDS: SessionDataService,
    private UTS: UtilitiesService,
    public TS: TranslateService
  ) {
    
    if (localStorage.getItem('currentAccount')) {
      const currentAccount = JSON.parse(
        localStorage.getItem('currentAccount')
      );
      if (currentAccount) {
        this.currentAccount = currentAccount;
      }
    }
  }

  ngOnInit() {
    this.language = localStorage.getItem('language') || 'en';
    this.TS.setDefaultLang(this.language);
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }

    this.ENV = this.UTS.getENV();
   // this.getUserInfo();
   // this.getCart();
  }

  getCart() {
    this.count = 0;
    this.AS.getShoppingCart().subscribe(
      (r: any) => {
        if (r && r.items) {
          this.count = r?.numberOfItemsInCart ? r?.numberOfItemsInCart : 0;
        }
      },
      (e) => {
        if (e && e.error) {
          // this.UTS.error(e.error.message);
        }
      }
    );
  }

  getUserInfo() {
    this.language =
      localStorage.getItem('language') &&
      localStorage.getItem('language').toLocaleLowerCase();
    this.AS.UserInfo().subscribe(
      (r: any) => {
        if (r) {
          this.userData = r;
          this.userLoggedIn = true;
        }
      },
      () => {
        this.userLoggedIn = false;
      }
    );
  }

  signIn() {
    window.location.href = environment.ECARE_URL;
  }

  // changeLangAction() {
  //   const lang = localStorage.getItem('language');

  //   if (lang.toLocaleLowerCase() == 'en') {
  //     localStorage.setItem('language', 'ar');
  //     this.TS.setDefaultLang('ar');
  //     const url =
  //       window.location.href.split('?') && window.location.href.split('?')[0]
  //         ? window.location.href.split('?')[0] +
  //           '?skuId=' +
  //           this.sku.skuId +
  //           '&lang=ar'
  //         : window.location.href.split('?')[0] + '?lang=ar';

  //     window.location.href = url;

  //     window.location.reload();
  //   }

  //   if (lang.toLocaleLowerCase() == 'ar') {
  //     localStorage.setItem('language', 'en');
  //     this.TS.setDefaultLang('en');
  //     const url =
  //       window.location.href.split('?') && window.location.href.split('?')[0]
  //         ? window.location.href.split('?')[0] +
  //           '?skuId=' +
  //           this.sku.skuId +
  //           '&lang=en'
  //         : window.location.href.split('?')[0] + '?lang=en';

  //     window.location.href = url;

  //     window.location.reload();
  //   }
  // }

  changeLangAction() {
    const lang = localStorage.getItem('language');
  
    if (lang.toLocaleLowerCase() === 'en') {
      localStorage.setItem('language', 'ar');
      this.TS.setDefaultLang('ar');
      const url = this.generateUrl('ar');
      window.location.href = url;
    }
  
    if (lang.toLocaleLowerCase() === 'ar') {
      localStorage.setItem('language', 'en');
      this.TS.setDefaultLang('en');
      const url = this.generateUrl('en');
      window.location.href = url;
    }
  }
  
  generateUrl(language: string): string {
    const baseUrl = window.location.href.split('?')[0];
    const skuId = this.sku?.skuId ? `&skuId=${this.sku.skuId}` : '';
    return `${baseUrl}?locale=${language}${skuId}`;
  }
  

  logOut() {
    this.AS.logOut().subscribe((res) => {
      this.signIn();
    });
  }

  trackOrder() {
    window.location.href = environment.BASE_URL + '/userOrdersTracking';
  }

  goToCart() {
    const OS = this.UTS.getMobileOperatingSystem();
    if (this.ENV == 'mobile' && OS == 'Android') {
        window.deals.goToCartScreen();
    } else if (this.ENV == 'mobile' && OS == 'iOS') {
        (window as any).webkit.messageHandlers.eandridInterface.postMessage(
          'cart'
        );
    }

  }

  openDetailPage(sku: any, i: number) {
    this.SKUDS.set(sku);
    this.SDS.setAddon(this.addon);
    if (i == 0) {
      this.subscribe(sku);
    } else {
      if (this.addon == 'elife' || this.addon == 'tv') {
        this.route.navigate(['/addon/detail/elife']);
      } else {
        this.route.navigate(['/addon/detail']);
      }
    }
  }

  private subscribe(sku: any) {
    const userInfo: any = this.AS.getUInfo();
    if (userInfo && userInfo.mainServiceAccountNo) {
      this.SS.skuDetails.next(sku);
      this.openBottomSheet(VerificationComponent, {});
    } else {
      this.SS.skuDetails.next(sku);
      this.openBottomSheet(VerificationComponent, {});
    }
  }

  async openBottomSheet(component: any, data?: any) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      cssClass: 'verification-modal modal-fullscreen',
    });
    return await modal.present();
  }

  back() {
    const CAT = localStorage.getItem('CAT')
      ? localStorage.getItem('CAT')
      : AppSettings.POSTPAID;
    const subCategoryId = localStorage.getItem('subCategoryId');
    const url =
      '/addons?subCategory=' +
      CAT +
      '&categoryDimension=' +
      subCategoryId +
      '&locale=' +
      this.UTS.getLocaleLanguage();
    this.route.navigateByUrl(url);
  }
  gotoCreateRequest(){
    
    this.otpvalidation();
//this.route.navigateByUrl('/create-request/step1')
}

gotoTrackRequest(){
  const url = '/track-request/search'
  this.route.navigateByUrl(url);
}

gotoSupport(){
  
  const url = '/support'
  this.route.navigateByUrl(url);
}

private otpvalidation() {
  this.openBottomSheet(VerificationComponent, {});

}

cqPortal(){
  this.route.navigate(['/home']);
}

}
